import { VueQueryPlugin, type VueQueryPluginOptions } from "@tanstack/vue-query";

import { ApiError } from "~/core/utils/api";

export default defineNuxtPlugin((nuxtApp) => {

  const vueQueryOptions: VueQueryPluginOptions = {
    queryClientConfig: {
      defaultOptions: {
        queries: {
          throwOnError: true,
          retry: (failureCount, error) => {
            // Inutile de retenter une erreur client (4xx) : un 403/404/422 ne
            // se résout pas en réessayant — on évite la rafale de requêtes
            // (cf. la 403 sur /activity-categories/ rejouée 4× dans Sentry).
            if (
              error instanceof ApiError &&
              error.status !== undefined &&
              error.status >= 400 &&
              error.status < 500
            ) {
              return false;
            }
            return failureCount < 3;
          },
        },
        mutations: {
          throwOnError: true,
        },
      },
    },
  };
  nuxtApp.vueApp.use(VueQueryPlugin, vueQueryOptions);
});
